export default "__VITE_ASSET__Cpd5c9Xy__"